import classNames, {Argument} from 'classnames';
import * as React from 'react';
import {defineMessages, useIntl, WrappedComponentProps} from 'react-intl';

import styles from './AddButton.less';
import {IconButton} from './IconButton';
import {ClickItem} from 'src/js/common/types';
import {TranslateUtils} from 'src/js/common/utils';

const I18N = defineMessages({
  ADD: {
    id: 'common.addButton.add',
    defaultMessage: 'Add',
    description: 'title text for add button',
  },
});

interface OwnProps {
  className?: Argument;
  disabled?: boolean;
  item?: ClickItem;
  titleText?: string;
  addCallback: (item?: ClickItem) => void;
}

type Props = OwnProps & WrappedComponentProps;

export const AddButton: React.FC<Props> = (props) => {
  const {
    addCallback,
    className,
    disabled,
    item,
    titleText = 'common.addButton.add',
  } = props;

  const intl = useIntl();

  return (
    <IconButton
      item={item}
      className={classNames(className, {[styles.dlAddButton]: !disabled})}
      iconClass={'fas fa-plus'}
      clickCallback={addCallback}
      disabled={disabled}
      titleText={TranslateUtils.translate({...I18N.ADD, id: titleText}, intl)}
    />
  );
};

AddButton.displayName = 'AddButton';
